/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Picker_Last_YearInputs */

const fr_date_picker_last_year = /** @type {(inputs: Date_Picker_Last_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il y a un an`)
};

const en_date_picker_last_year = /** @type {(inputs: Date_Picker_Last_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A year ago`)
};

/**
* | output |
* | --- |
* | "A year ago" |
*
* @param {Date_Picker_Last_YearInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const date_picker_last_year = /** @type {((inputs?: Date_Picker_Last_YearInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Picker_Last_YearInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_date_picker_last_year(inputs)
	return fr_date_picker_last_year(inputs)
});